import {CompetitorStatus} from "./competitor";
import {MeasurementTypes} from "./race-settings";
import {RegistrationStatus} from "./race-registration/registration-status";

export class CompetitorFilter {

  constructor(
      public eventId?: number,
      public raceId?: number,
      public categories?: number[],
      public name?: string,
      public gender?: number,
      public competitorStatuses?: CompetitorStatus[],
      public registrationStatuses?: RegistrationStatus[],
      public status?: number,
      public measurementType?:MeasurementTypes,
      public isMeasurement?:boolean
  ) {
  }

}
